import React from 'react';
import { Drawer } from '@mui/material';
import PropTypes from 'prop-types';

function CustomDrawer({
  children,
  anchor = 'right',
  isOpen = false,
  toggleDrawer = () => {},
  width = 200,
  sx = {},
  PaperProps = {},
}) {
  return (
    <Drawer
      sx={{
        width,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width, boxSizing: 'border-box' },
        ...sx,
      }}
      anchor={anchor}
      open={isOpen}
      onClose={() => toggleDrawer(false)}
      PaperProps={PaperProps}
    >
      {children}
    </Drawer>
  );
}

CustomDrawer.propTypes = {
  anchor: PropTypes.oneOf(['right', 'bottom', 'left', 'top']),
  isOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
  PaperProps: PropTypes.object,
};

export default CustomDrawer;
